/**
 * CRM Events API
 * Event tracking: recent activity, calls, missed calls
 */

import { crmGet } from './crmConfig';

/**
 * Fetch recent events
 * @param {Object} params - Optional query parameters
 */
export const fetchRecentEvents = async (params) => {
  const response = await crmGet('/api/events/recent', params);
  return response.data;
};

/**
 * Fetch call events
 * @param {Object} params - Optional query parameters
 */
export const fetchCallEvents = async (params) => {
  const response = await crmGet('/api/events/calls', params);
  return response.data;
};

/**
 * Fetch missed call events
 * @param {Object} params - Optional query parameters
 */
export const fetchMissedCalls = async (params) => {
  const response = await crmGet('/api/events/missed', params);
  return response.data;
};
